import { getLookupValuePageTabs } from './lookups';
import { updatePageLoadData } from './send';

export const setArticleTitle = (articleTitle: string): void => {
  updatePageLoadData({ articleTitle: getLookupValuePageTabs(articleTitle) });
};

export const isAnalyticsEnabled = (): boolean => !window.analyticsDisabled;
